import React from 'react'
import { Box, Pagination, PaginationItem } from '@mui/material'
import { styled } from '@mui/material/styles'

interface PaginationControlProps {
  /**
   * 現在のページ番号
   */
  currentPage: number

  /**
   * 総ページ数
   */
  totalPages: number

  /**
   * ページ変更時に呼び出されるコールバック関数
   */
  onPageChange: (page: number) => void
}

// スタイル付きのページネーション
const StyledPagination = styled(Pagination)(({ theme }) => ({
  '& .MuiPaginationItem-root': {
    margin: theme.spacing(0, 0.5),
  },
  '& .Mui-selected': {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
  },
}))

/**
 * ページネーション機能を提供するコンポーネント
 */
const PaginationControl: React.FC<PaginationControlProps> = ({
  currentPage,
  totalPages,
  onPageChange,
}) => {
  // ページ数が1の場合は何も表示しない
  if (totalPages <= 1) {
    return null
  }

  // ページ変更ハンドラー
  const handleChange = (_: React.ChangeEvent<unknown>, page: number) => {
    onPageChange(page)
  }

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        my: 2,
      }}
    >
      <StyledPagination
        count={totalPages}
        page={currentPage}
        onChange={handleChange}
        shape="rounded"
        color="primary"
        size="medium"
        showFirstButton
        showLastButton
        siblingCount={1}
        boundaryCount={1}
        renderItem={(item) => (
          <PaginationItem
            {...item}
            // アクセシビリティ属性を追加
            aria-label={
              item.type === 'page'
                ? `${item.page}ページ目へ移動`
                : item.type === 'first'
                ? '最初のページへ移動'
                : item.type === 'last'
                ? '最後のページへ移動'
                : item.type === 'previous'
                ? '前のページへ移動'
                : '次のページへ移動'
            }
          />
        )}
      />
    </Box>
  )
}

export default PaginationControl
